import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import Moment from 'react-moment';
import moment from 'moment';
import { useDispatch } from 'react-redux';

function ExperienceOverview({ experience }) {
  const dispatch = useDispatch();

  const columns = [
    {
      dataField: 'company',
      text: 'Company',
    },
    {
      dataField: 'title',
      text: 'Title',
    },
    {
      dataField: 'from',
      text: 'Years',
      formatter: (cell, row) => (
        <span>
          <Moment format="DD/MM/YYYY">{moment.utc(row.from)}</Moment> -{' '}
          {row.to === null ? ' Now' : <Moment format="DD/MM/YYYY">{moment.utc(row.to)}</Moment>}
        </span>
      ),
    },
    {
      dataField: 'description',
      text: 'Description',
    },
  ];

  return (
    <div>
      <h5 className="mb-4">Experience Credentials</h5>
      <BootstrapTable
        keyField="_id"
        data={experience}
        columns={columns}
        classes="table-responsive-md"
        wrapperClasses="table-responsive"
      />
    </div>
  );
}

ExperienceOverview.propTypes = {
  experience: PropTypes.array.isRequired,
};

export default ExperienceOverview;
